// *TODO: refactor resolver qualities and other qualities to be of same
// data type for easy db-storage.

export enum ResolverQualityLevel {
  HIGH = 5,
  MEDIUM_PLUS = 4,
  MEDIUM = 3,
  LOW = 2,
  VERY_LOW = 1,
  POOR = 0,
}

export enum SpecialProductSetQuality {
  MANUAL = 'M',
  MANUAL_INHERITED = 'MI',
  MICROWORK = 'W',
  GPT = 'GPT',
  LITE = 'L',
  OTHER = 'O',
  NONE = '-',
}

// In order
export const productSetQualityLevels = [
  SpecialProductSetQuality.MANUAL,
  SpecialProductSetQuality.MANUAL_INHERITED,
  SpecialProductSetQuality.MICROWORK,
  SpecialProductSetQuality.GPT,
  SpecialProductSetQuality.LITE,
  SpecialProductSetQuality.OTHER,
  SpecialProductSetQuality.NONE,
];

export type CompanyProductSetQuality = SpecialProductSetQuality | ResolverQualityLevel;

export const allQualityLevels = [
  ResolverQualityLevel.HIGH,
  ResolverQualityLevel.MEDIUM_PLUS,
  ResolverQualityLevel.MEDIUM,
  ResolverQualityLevel.LOW,
  ResolverQualityLevel.VERY_LOW,
  ResolverQualityLevel.POOR,
];

export const manualProductSetQualities = [SpecialProductSetQuality.MANUAL, SpecialProductSetQuality.MANUAL_INHERITED];

export function stringToQualityLevel(s: string | undefined) {
  if (s === SpecialProductSetQuality.MANUAL) {
    return SpecialProductSetQuality.MANUAL;
  } else if (s === SpecialProductSetQuality.MANUAL_INHERITED) {
    return SpecialProductSetQuality.MANUAL_INHERITED;
  } else if (s === SpecialProductSetQuality.MICROWORK) {
    return SpecialProductSetQuality.MICROWORK;
  } else if (s === SpecialProductSetQuality.GPT) {
    return SpecialProductSetQuality.GPT;
  } else if (s === SpecialProductSetQuality.LITE) {
    return SpecialProductSetQuality.LITE;
  } else if (s === SpecialProductSetQuality.OTHER) {
    return SpecialProductSetQuality.OTHER;
  } else if (s && allQualityLevels.includes(parseInt(s, 10))) {
    return parseInt(s, 10);
  } else {
    return SpecialProductSetQuality.NONE;
  }
}

// N.B.: also consider productSetComparisonValue
export function productSetQualityToNumber(quality: CompanyProductSetQuality | undefined): number {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (quality) {
    case SpecialProductSetQuality.MANUAL:
      return 999999;
    case SpecialProductSetQuality.MANUAL_INHERITED:
      return 99999;
    case SpecialProductSetQuality.GPT:
      return 9999 + 1000;
    case SpecialProductSetQuality.MICROWORK:
      return 9999;
    case SpecialProductSetQuality.LITE:
      return 999;
    case SpecialProductSetQuality.OTHER:
      return 99;
    default:
      return typeof quality === 'number' ? (quality as number) + 1 : 0;
  }
}
